import { createRequest, handleErrorCatchLog } from '../../Helpers/GenericHelpers'
import { retrieveSelectedArticleKey } from '../../Helpers/ArticlesHelper'
import { getTokenFromSessionStorage } from 'Helpers/TokenHelper'
import { handlePubblications, retrieveArticleDetailData } from './ArticleServices'

const savePubblicationChanges = changedPubblication => (dispatch, getState) => {
  const state = getState()
  const rowKeysSelected = state.present.article.rowKeysSelected
  const token = getTokenFromSessionStorage()

  const articleKey: any = retrieveSelectedArticleKey(rowKeysSelected)

  if (!state.present.article.serverConfig || !articleKey || !token) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  const body = {
    PubblicationsField: changedPubblication,
  }

  return createRequest(
    '/api/articles/' + articleKey + '/updatePubblications?config=' + state.present.article.serverConfig,
    'POST',
    body,
    token,
  )
    .then(response => {
      retrieveArticleDetailData(articleKey, dispatch)
      return response
    })
    .catch(err => {
      handleErrorCatchLog(err, 'Failed to save pubblication changes')
    })
}

export { savePubblicationChanges }
